import DashboardIcon from "@material-ui/icons/Dashboard";
import SettingsIcon from "@material-ui/icons/Settings";
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import FolderOpenIcon from '@material-ui/icons/FolderOpen';
import ChangePassword from "views/ChangePassword/ChangePassword";
import Dashboard from "views/Dashboard/Dashboard";
import Options from "views/Options/Options";
import Downloads from "views/Downloads/Downloads";
import Attendance from "views/Attendance/Attendance";
import Recovery from "views/Password/Recovery";
import ManagementRequest from "views/Request/ManagementRequest/ManagementRequest";
import Request from "views/Request/Request";

export const attendance_login = {
  path: "/attendance/login",
  component: Attendance,
  layout: "/admin",
  invisible: true
};

export const password_recovery = {
  path: "/password/recovery/:id",
  component: Recovery,
  layout: "/admin",
  invisible: true
};

export const attendance_logout = {
  path: "/attendance/logout",
  component: Attendance,
  layout: "/admin",
  invisible: true
};

export const change_password = {
  path: "/changepassword/",
  component: ChangePassword,
  layout: "/admin",
  invisible: true
};

export const dashboard = {
  path: "/dashboard",
  name: "Dashboard",
  rtlName: "لوحة القيادة",
  icon: DashboardIcon,
  component: Dashboard,
  layout: "/admin"
};

export const options = {
  path: "/options",
  name: "Opciones",
  rtlName: "لوحة القيادة",
  icon: SettingsIcon,
  component: Options,
  layout: "/admin"
};

export const download = {
  path: "/downloads",
  name: "Descargas",
  rtlName: "لوحة القيادة",
  icon: CloudDownloadIcon,
  component: Downloads,
  layout: "/admin"
};

export const request = {
  path: "/request/",
  name: "Solicitudes",
  icon: FolderOpenIcon,
  component: Request,
  layout: "/admin"
}

export const request_ = {
  path: "/request/",
  name: "Mis tareas",
  rtlName: "رد فعل الطاولة",
  mini: ".",
  rtlMini: "در",
  component: Request,
  layout: "/admin"
};

export const management_request = {
  path: "/managementrequest/",
  name: "Solicitudes",
  icon: FolderOpenIcon,
  component: ManagementRequest,
  layout: "/admin"
};
